// AXIOM — signed local acceptance run plans.
//
// This is intentionally not a transport and never manufactures a score,
// digest, receipt, leaderboard row or ticket.  The platform may attach a
// verified claim to a loopback acceptance URL; only then does the game choose
// one of these deterministic *input plans*.  Portal always uses the official
// SDK connect() path.

export const LOCAL_VARIANT_QUERY = 'axiom-local-variants-v1';
export const LOCAL_VARIANTS = Object.freeze(['base', 'tie', 'challenger', 'self']);
const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]', '::1']);

function hostOf(locationLike) {
  return String(locationLike?.hostname ?? '').toLowerCase();
}

/**
 * Resolve a variant only on the runtime launch shape.  `s` is a server-issued
 * session claim bound by the platform; the game only requires exactly one
 * non-empty value and never interprets it as a score or a signature.
 */
export function resolveLocalVariant(locationLike = globalThis.location) {
  if (!LOCAL_HOSTS.has(hostOf(locationLike))) return null;
  if (locationLike?.protocol !== undefined && locationLike.protocol !== 'http:') return null;
  const params = new URLSearchParams(String(locationLike?.search ?? ''));
  if (params.size !== 2 || params.getAll('s').length !== 1 || params.getAll(LOCAL_VARIANT_QUERY).length !== 1) return null;
  if (!params.get('s')) return null;
  const value = params.get(LOCAL_VARIANT_QUERY);
  return LOCAL_VARIANTS.includes(value) ? value : null;
}

// Only ordinary game inputs vary.  The score remains whatever the engine's
// weapon/enemy/state pipeline produces, and the platform still owns every
// comparison, receipt and ranking decision.
const PLANS = Object.freeze({
  base: Object.freeze({ enemyCount: 1, weaponHits: 6, headshot: false, weaponIndex: 0, deathDelayMs: 8000 }),
  tie: Object.freeze({ enemyCount: 1, weaponHits: 6, headshot: false, weaponIndex: 0, deathDelayMs: 8000 }),
  challenger: Object.freeze({ enemyCount: 1, weaponHits: 6, headshot: true, weaponIndex: 2, deathDelayMs: 8000 }),
  self: Object.freeze({ enemyCount: 1, weaponHits: 6, headshot: true, weaponIndex: 2, deathDelayMs: 8000 }),
});

export function localVariantPlan(variant) {
  const plan = PLANS[variant];
  return plan ? Object.freeze({ variant, ...plan }) : null;
}
